import React, {useMemo} from "react";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {CacheProvider} from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import {prefixer} from "stylis";
import {useUser} from "../context/UserProvider";
import LoadingWidget from "../components/LoadingWidget";
import {CssBaseline} from "@mui/material"; // Import user context

const ThemeConfig = ({children}) => {
    const {settings, user, loading} = useUser(); // Get settings

    // Provide default values while loading
    const defaultSettings = {
        siteLang: "en",
        themeColor: "#ffffff",
        secThemeColor: "#ffffff"
    };

    const finalSettings = loading || !settings ? defaultSettings : settings;

    // Memoized Theme
    const theme = useMemo(
        () =>
            createTheme({
                direction: finalSettings.siteLang === "ar" ? "rtl" : "ltr",
                palette: {
                    primary: {main: finalSettings.themeColor},
                    mode: user && user.settings?.darkMode ? "dark" : "light",
                    secondary: {main: finalSettings.secThemeColor}
                },
            }),
        [finalSettings, user]
    );



    // Memoized Cache for RTL Support
    const cacheRtl = useMemo(
        () =>
            createCache({
                key: "muirtl",
                stylisPlugins: finalSettings.siteLang === "ar" ? [prefixer, rtlPlugin] : [],
            }),
        [finalSettings]
    );

    console.log(finalSettings, user ? user.settings : null)

    // Show loading indicator but **DO NOT RETURN EARLY**
    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                {loading ? <div className={"fullScreen theme-loading"}><LoadingWidget/></div> : children}
            </ThemeProvider>
        </CacheProvider>
    );
};

export default ThemeConfig;
